
  import { Options, Vue } from "vue-class-component";
  import { calculateProgressIndicatorOffset } from "../utils/modules";


  @Options({
    props: {
      progress: Number
    }
  } as any)
  export default class ModuleProgresBar extends Vue {
    progress = 0;
    progressIndicatorOffset = 0;

    mounted() {
      this.updateProgressIndicatorOffset();
      window.addEventListener('resize', this.updateProgressIndicatorOffset);
    }

    beforeUnmount() {
      window.removeEventListener('resize', this.updateProgressIndicatorOffset);
    }

    updateProgressIndicatorOffset() {
      const progressBarWidth = (this.$refs.progressBar as HTMLElement).clientWidth;
      const progressIndicatorWidth = (this.$refs.progressIndicator as HTMLElement).offsetWidth;
      this.progressIndicatorOffset = calculateProgressIndicatorOffset(progressBarWidth, progressIndicatorWidth, this.progress);
    }
  }
